/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-21 18:39:37
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-06-14 09:36:56
 */
import request from '../../utils/request'
import server from './config'
export default {
  /**
   * 获取服务包记录详情
   */
  getDetail:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/service/agg/reccord/1/serviceAggRecordInfo`,
      method: 'post',
      data,
    })
  },
  getServiceList:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/agg/reccord/1/serviceAggRecordPage`,
        method: 'post',
        data,
      })
  },
  //创建服务包订单
  setServiceOrder:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/agg/order/1/createServiceAggOrder`,
        method: 'post',
        data,
      })
  },
  //创建服务包订单优化版
  createServiceAggOrderWithApplyDevice:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/agg/order/1/createServiceAggOrderWithApplyDevice`,
        method: 'post',
        data,
      })
  },
  /**
   * 查询服务包订单列表
   */
  servicePackageOrderList:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/personalcenter/1/servicePackageList`,
        method: 'post',
        data,
      })
  },
  notInterested:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/agg/reccord/1/notInterested`,
        method: 'post',
        data,
      })
  },
  /**
   * 服务包订单详情
   */
  servicePackOrderInfo:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/personalcenter/1/servicePackageInfo`,
        method: 'post',
        data
      })
  },
  /**
   * 取消订单
   */
  confirmCancel:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/personalcenter/1/confirmCancel`,
        method: 'post',
        data,
      })
  },
  /**
   * 获取分组下药店信息
   */
  getMerchantDetailByGroup:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/agg/reccord/1/getMerchantDetailByGroup`,
        method: 'post',
        data
      })
  },
  //生成服务记录
  createServiceAggRecord:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/agg/reccord/1/createServiceAggRecord`,
        method: 'post',
        data,
      })
  },
  //获取使用详情
  getServiceRecordDetailList:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/agg/reccord/1/getServiceRecordDetailList`,
        method: 'post',
        data,
      })
  },
  //获取取货码
  getConsigneeCode:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/agg/order/1/getConsigneeCode`,
        method: 'post',
        data,
      })
  },
  //近7天是否购买过保险服务包
  querySevenDaysIsPurchaseAgg:(data)=>{
    return request({
        url:`${server.MS_PATIENT_CONSUMMER}/service/agg/order/1/querySevenDaysIsPurchaseAgg`,
        method: 'post',
        data,
      })
  },

  // 下单前进行基础校验
  checkServiceAggOrder: data => {
    return request({
        url: `${server.MS_PATIENT_CONSUMMER}/service/agg/order/1/base/check/create/serviceAgg`,
        method: "post",
        data
    });
},
}



// WEBPACK FOOTER //
// ./src/api/modules/servicePack.js